<template>
  <material-card>
    <v-toolbar slot="header" color="primary">
      <v-toolbar-title>Merchants</v-toolbar-title>
    </v-toolbar>

    <v-data-table
      :headers="merchantsTable.headers"
      :items="merchants"
      :options.sync="merchantsTableOptions"
      :server-items-length="rows"
      :loading="loading"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 20, 30, 50]
      }"
      :items-per-page="itemsPerPage"
    >
      <template slot="headerCell" slot-scope="{ header }">
        <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
      </template>
      <template v-slot:item.name="{ item }">
        <a @click="goToMerchant(item)" dark>{{ item.name }}</a>
      </template>
    </v-data-table>
  </material-card>
</template>
<script>
export default {
  props: {
    merchants: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    rows: {
      // TODO Correct lifecycle error, rows are first provided as undefined and
      // throws exception if prop is required
      type: Number
    },
    loading: {
      type: Boolean
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 15
    }
  },
  data () {
    return {
      merchantsTable: {
        headers: [
          {
            text: 'Merchant',
            value: 'name'
          },
          {
            text: 'Client',
            sortable: true,
            value: 'client_name'
          },
          {
            text: 'Client relationship',
            value: 'relation_name'
          },
          {
            text: 'Vat Number',
            value: 'vat_number'
          }
        ],
        options: {},
        data: [],
        total: 0,
        loading: true
      },
      merchantsTableOptions: {}
    }
  },
  methods: {
    /**
   * Navigation to campaign detail
   */
    goToMerchant (item) {
      this.$router.push({
        name: 'merchantdetail',
        params: { merchantId: item.id }
      })
    }
  }
}
</script>
